// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .tenant-administrator-invoices-page{
        position: relative;
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    .tenant-administrator-invoices-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .tenant-administrator-invoices-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tenant-administrator-reloading-invoices-parent-container,
    .tenant-administrator-loading-invoices-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80%;
    }
    .tenant-administrator-reloading-invoices-container,
    .tenant-administrator-loading-invoices-container{
        text-align: center;
        margin-bottom: 10vh;
    }
    .tenant-administrator-reloading-invoices-container div,
    .tenant-administrator-loading-invoices-container div{
        height: 40px;
        width: 40px;
        display: inline-block;
        border: 2px solid rgba(155, 30, 30, 0.952);
        border-top-color: transparent;
        border-radius: 50%;
        animation: tenant-administrator-loading-invoices-spinner 1s linear infinite;
    }
    @keyframes tenant-administrator-loading-invoices-spinner {
        from{
            transform: rotate(0deg);
        }
        to{
            transform: rotate(360deg);
        }
    }
    .tenant-administrator-reloading-invoices-container p,
    .tenant-administrator-loading-invoices-container p{
        cursor: default;
        color: rgb(48, 48, 48);
        font-size: 16px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-invoices-unavailable-container{
        margin-bottom: 10vh;
        padding: 12px 28px;
        border-radius: 4px;
        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);
    }
    .tenant-administrator-invoices-unavailable-container h2{
        margin: 5px 0px;
        font-weight: 500;
        font-size: 20px;
        color: rgb(85, 85, 85);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-invoices-unavailable-container p{
        margin: 12px 0px;
        font-size: 15px;
        color: rgb(56, 56, 56);
    }
    .tenant-administrator-invoices-unavailable-container div{
        text-align: right;
        padding: 5px 0px;
    }
    .tenant-administrator-invoices-unavailable-container div button{
        border: none;
        color: white;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        background-color: rgb(48, 105, 152);
        transition: background-color 0.25s ease-in-out;
    }
    .tenant-administrator-invoices-unavailable-container div button:hover{
        background-color: rgb(35, 85, 125);
    }
    .tenant-administrator-invoices-container{
        width: 90%;
        height: 85%;
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    }
    .tenant-administrator-invoices-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tenant-administrator-invoices-header h2{
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .tenant-administrator-invoices-header-controls{
        display: flex;
        align-items: center;
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button{
        border: none;
        border-radius: 50%;
        padding: 5px 9px;
        cursor: pointer;
        background-color: transparent;
        transition: background-color 0.25s ease;
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button:hover{
        background-color: rgb(221, 221, 221);
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button img{
        height: 25px;
        margin-top: 4px;
    }
    .tenant-administrator-invoices-header-controls .add-invoice-button{
        border: none;
        border-radius: 50%;
        padding: 5px 8px;
        cursor: pointer;
        background-color: transparent;
        transition: background-color 0.25s ease;
    }
    .tenant-administrator-invoices-header-controls .add-invoice-button:hover{
        background-color: rgb(221, 221, 221);
    }
    .tenant-administrator-invoices-header-controls .add-invoice-button img{
        height: 25px;
    }
    .tenant-administrator-invoices-container table{
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    #tenant-administrator-invoices-table-header-row{
        background-color: transparent;
    }
    .tenant-administrator-invoices-container table th,
    .tenant-administrator-invoices-container table td{
        text-align: left;
        white-space: nowrap;
    }
    .tenant-administrator-invoices-container table th:last-child,
    .tenant-administrator-invoices-container table td:last-child{
        width: 5%;
    }
    .tenant-administrator-invoices-container table th{
        font-weight: 500;
        padding: 10px 5px;
        cursor: default;
    }
    .tenant-administrator-invoices-container table td{
        font-size: 14px;
        padding: 4px 5px;
    }
    .tenant-administrator-invoices-container table td:last-child img{
        height: 25px;
    }
    .tenant-administrator-invoices-container table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .tenant-administrator-invoices-container table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}
@media screen and (max-width:949px){
    .tenant-administrator-invoices-page{
        position: relative;
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
    .tenant-administrator-invoices-page-layout{
        height: 90%;
        box-sizing: border-box;
    }
    .tenant-administrator-invoices-parent-container{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tenant-administrator-loading-invoices-container{
        text-align: center;
        margin-bottom: 10vh;
    }
    .tenant-administrator-loading-invoices-container div{
        height: 40px;
        width: 40px;
        display: inline-block;
        border: 2px solid rgba(155, 30, 30, 0.952);
        border-top-color: transparent;
        border-radius: 50%;
        animation: tenant-administrator-loading-invoices-spinner 1s linear infinite;
    }
    @keyframes tenant-administrator-loading-invoices-spinner {
        from{
            transform: rotate(0deg);
        }
        to{
            transform: rotate(360deg);
        }
    }
    .tenant-administrator-loading-invoices-container p{
        cursor: default;
        color: rgb(48, 48, 48);
        font-size: 16px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-invoices-unavailable-container{
        margin-bottom: 10vh;
        padding: 12px 28px;
        border-radius: 4px;
        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);
    }
    .tenant-administrator-invoices-unavailable-container h2{
        margin: 5px 0px;
        font-weight: 500;
        font-size: 20px;
        color: rgb(85, 85, 85);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-administrator-invoices-unavailable-container p{
        margin: 12px 0px;
        font-size: 15px;
        color: rgb(56, 56, 56);
    }
    .tenant-administrator-invoices-unavailable-container div{
        display: none;
    }











    .tenant-administrator-invoices-container{
        height: 98%;
        padding: 2% 4%;
        margin-bottom: 4vh;
        position: relative;
    }
    .tenant-administrator-invoices-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tenant-administrator-invoices-header h2{
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .tenant-administrator-invoices-header-controls{
        display: flex;
        align-items: center;
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button{
        border: none;
        border-radius: 50%;
        padding: 5px 9px;
        cursor: pointer;
        background-color: transparent;
        transition: background-color 0.25s ease;
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button:hover{
        background-color: rgb(221, 221, 221);
    }
    .tenant-administrator-invoices-header-controls .search-invoice-button img{
        height: 25px;
        margin-top: 4px;
    }
    .tenant-administrator-invoices-header-controls .add-invoice-button{
        display: none;
    }
    .tenant-administrator-invoices-container table{
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    #tenant-administrator-invoices-table-header-row{
        background-color: transparent;
    }
    .tenant-administrator-invoices-container table th,
    .tenant-administrator-invoices-container table td{
        text-align: left;
        white-space: nowrap;
    }
    .tenant-administrator-invoices-container table th:first-child,
    .tenant-administrator-invoices-container table td:first-child,
    .tenant-administrator-invoices-container table th:nth-child(2),
    .tenant-administrator-invoices-container table td:nth-child(2),
    .tenant-administrator-invoices-container table th:last-child,
    .tenant-administrator-invoices-container table td:last-child{
        display: none;
    }
    .tenant-administrator-invoices-container table th{
        font-weight: 500;
        padding: 10px 5px;
        cursor: default;
    }
    .tenant-administrator-invoices-container table td{
        font-size: 14px;
        padding: 4px 5px;
    }
    .tenant-administrator-invoices-container table td:last-child img{
        height: 25px;
    }
    .tenant-administrator-invoices-container table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .tenant-administrator-invoices-container table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Invoices/Invoices.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,gDAAgD;IACpD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;;QAEI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;IACA;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;;QAEI,YAAY;QACZ,WAAW;QACX,qBAAqB;QACrB,0CAA0C;QAC1C,6BAA6B;QAC7B,kBAAkB;QAClB,2EAA2E;IAC/E;IACA;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;IACJ;IACA;;QAEI,eAAe;QACf,sBAAsB;QACtB,eAAe;QACf,4DAA4D;IAChE;IACA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,8CAA8C;IAClD;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,mCAAmC;QACnC,8CAA8C;IAClD;IACA;QACI,kCAAkC;IACtC;IACA;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,sCAAsC;IAC1C;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,uCAAuC;IAC3C;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,uCAAuC;IAC3C;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,yBAAyB;QACzB,4DAA4D;IAChE;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;;QAEI,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,gDAAgD;IACpD;IACA;QACI,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,WAAW;QACX,qBAAqB;QACrB,0CAA0C;QAC1C,6BAA6B;QAC7B,kBAAkB;QAClB,2EAA2E;IAC/E;IACA;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;IACJ;IACA;QACI,eAAe;QACf,sBAAsB;QACtB,eAAe;QACf,4DAA4D;IAChE;IACA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,8CAA8C;IAClD;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;;;;;;;;;;;;IAYA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,uCAAuC;IAC3C;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,yBAAyB;QACzB,4DAA4D;IAChE;IACA;QACI,6BAA6B;IACjC;IACA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;;;;;;QAMI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .tenant-administrator-invoices-page{\n        position: relative;\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        box-sizing: border-box;\n        font-family: Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .tenant-administrator-invoices-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    .tenant-administrator-invoices-parent-container{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .tenant-administrator-reloading-invoices-parent-container,\n    .tenant-administrator-loading-invoices-parent-container{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 80%;\n    }\n    .tenant-administrator-reloading-invoices-container,\n    .tenant-administrator-loading-invoices-container{\n        text-align: center;\n        margin-bottom: 10vh;\n    }\n    .tenant-administrator-reloading-invoices-container div,\n    .tenant-administrator-loading-invoices-container div{\n        height: 40px;\n        width: 40px;\n        display: inline-block;\n        border: 2px solid rgba(155, 30, 30, 0.952);\n        border-top-color: transparent;\n        border-radius: 50%;\n        animation: tenant-administrator-loading-invoices-spinner 1s linear infinite;\n    }\n    @keyframes tenant-administrator-loading-invoices-spinner {\n        from{\n            transform: rotate(0deg);\n        }\n        to{\n            transform: rotate(360deg);\n        }\n    }\n    .tenant-administrator-reloading-invoices-container p,\n    .tenant-administrator-loading-invoices-container p{\n        cursor: default;\n        color: rgb(48, 48, 48);\n        font-size: 16px;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-invoices-unavailable-container{\n        margin-bottom: 10vh;\n        padding: 12px 28px;\n        border-radius: 4px;\n        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);\n    }\n    .tenant-administrator-invoices-unavailable-container h2{\n        margin: 5px 0px;\n        font-weight: 500;\n        font-size: 20px;\n        color: rgb(85, 85, 85);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-invoices-unavailable-container p{\n        margin: 12px 0px;\n        font-size: 15px;\n        color: rgb(56, 56, 56);\n    }\n    .tenant-administrator-invoices-unavailable-container div{\n        text-align: right;\n        padding: 5px 0px;\n    }\n    .tenant-administrator-invoices-unavailable-container div button{\n        border: none;\n        color: white;\n        padding: 8px 16px;\n        border-radius: 4px;\n        cursor: pointer;\n        background-color: rgb(48, 105, 152);\n        transition: background-color 0.25s ease-in-out;\n    }\n    .tenant-administrator-invoices-unavailable-container div button:hover{\n        background-color: rgb(35, 85, 125);\n    }\n    .tenant-administrator-invoices-container{\n        width: 90%;\n        height: 85%;\n        padding: 2% 3%;\n        border-radius: 5px;\n        position: relative;\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n    }\n    .tenant-administrator-invoices-header{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .tenant-administrator-invoices-header h2{\n        font-weight: lighter;\n        color: rgb(90, 90, 90);\n    }\n    .tenant-administrator-invoices-header-controls{\n        display: flex;\n        align-items: center;\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button{\n        border: none;\n        border-radius: 50%;\n        padding: 5px 9px;\n        cursor: pointer;\n        background-color: transparent;\n        transition: background-color 0.25s ease;\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button:hover{\n        background-color: rgb(221, 221, 221);\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button img{\n        height: 25px;\n        margin-top: 4px;\n    }\n    .tenant-administrator-invoices-header-controls .add-invoice-button{\n        border: none;\n        border-radius: 50%;\n        padding: 5px 8px;\n        cursor: pointer;\n        background-color: transparent;\n        transition: background-color 0.25s ease;\n    }\n    .tenant-administrator-invoices-header-controls .add-invoice-button:hover{\n        background-color: rgb(221, 221, 221);\n    }\n    .tenant-administrator-invoices-header-controls .add-invoice-button img{\n        height: 25px;\n    }\n    .tenant-administrator-invoices-container table{\n        width: 100%;\n        table-layout: fixed;\n        border-collapse: collapse;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    #tenant-administrator-invoices-table-header-row{\n        background-color: transparent;\n    }\n    .tenant-administrator-invoices-container table th,\n    .tenant-administrator-invoices-container table td{\n        text-align: left;\n        white-space: nowrap;\n    }\n    .tenant-administrator-invoices-container table th:last-child,\n    .tenant-administrator-invoices-container table td:last-child{\n        width: 5%;\n    }\n    .tenant-administrator-invoices-container table th{\n        font-weight: 500;\n        padding: 10px 5px;\n        cursor: default;\n    }\n    .tenant-administrator-invoices-container table td{\n        font-size: 14px;\n        padding: 4px 5px;\n    }\n    .tenant-administrator-invoices-container table td:last-child img{\n        height: 25px;\n    }\n    .tenant-administrator-invoices-container table tr:nth-child(even){\n        cursor: pointer;\n        background-color: rgb(242, 242, 242);\n    }\n    .tenant-administrator-invoices-container table tr:nth-child(odd){\n        cursor: pointer;\n        background-color: rgba(206, 206, 206, 0.952);\n    }\n}\n@media screen and (max-width:949px){\n    .tenant-administrator-invoices-page{\n        position: relative;\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        box-sizing: border-box;\n        font-family: Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .tenant-administrator-invoices-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n    }\n    .tenant-administrator-invoices-parent-container{\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .tenant-administrator-loading-invoices-container{\n        text-align: center;\n        margin-bottom: 10vh;\n    }\n    .tenant-administrator-loading-invoices-container div{\n        height: 40px;\n        width: 40px;\n        display: inline-block;\n        border: 2px solid rgba(155, 30, 30, 0.952);\n        border-top-color: transparent;\n        border-radius: 50%;\n        animation: tenant-administrator-loading-invoices-spinner 1s linear infinite;\n    }\n    @keyframes tenant-administrator-loading-invoices-spinner {\n        from{\n            transform: rotate(0deg);\n        }\n        to{\n            transform: rotate(360deg);\n        }\n    }\n    .tenant-administrator-loading-invoices-container p{\n        cursor: default;\n        color: rgb(48, 48, 48);\n        font-size: 16px;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-invoices-unavailable-container{\n        margin-bottom: 10vh;\n        padding: 12px 28px;\n        border-radius: 4px;\n        box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);\n    }\n    .tenant-administrator-invoices-unavailable-container h2{\n        margin: 5px 0px;\n        font-weight: 500;\n        font-size: 20px;\n        color: rgb(85, 85, 85);\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .tenant-administrator-invoices-unavailable-container p{\n        margin: 12px 0px;\n        font-size: 15px;\n        color: rgb(56, 56, 56);\n    }\n    .tenant-administrator-invoices-unavailable-container div{\n        display: none;\n    }\n\n\n\n\n\n\n\n\n\n\n\n    .tenant-administrator-invoices-container{\n        height: 98%;\n        padding: 2% 4%;\n        margin-bottom: 4vh;\n        position: relative;\n    }\n    .tenant-administrator-invoices-header{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    .tenant-administrator-invoices-header h2{\n        font-weight: lighter;\n        color: rgb(90, 90, 90);\n    }\n    .tenant-administrator-invoices-header-controls{\n        display: flex;\n        align-items: center;\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button{\n        border: none;\n        border-radius: 50%;\n        padding: 5px 9px;\n        cursor: pointer;\n        background-color: transparent;\n        transition: background-color 0.25s ease;\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button:hover{\n        background-color: rgb(221, 221, 221);\n    }\n    .tenant-administrator-invoices-header-controls .search-invoice-button img{\n        height: 25px;\n        margin-top: 4px;\n    }\n    .tenant-administrator-invoices-header-controls .add-invoice-button{\n        display: none;\n    }\n    .tenant-administrator-invoices-container table{\n        width: 100%;\n        table-layout: fixed;\n        border-collapse: collapse;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    #tenant-administrator-invoices-table-header-row{\n        background-color: transparent;\n    }\n    .tenant-administrator-invoices-container table th,\n    .tenant-administrator-invoices-container table td{\n        text-align: left;\n        white-space: nowrap;\n    }\n    .tenant-administrator-invoices-container table th:first-child,\n    .tenant-administrator-invoices-container table td:first-child,\n    .tenant-administrator-invoices-container table th:nth-child(2),\n    .tenant-administrator-invoices-container table td:nth-child(2),\n    .tenant-administrator-invoices-container table th:last-child,\n    .tenant-administrator-invoices-container table td:last-child{\n        display: none;\n    }\n    .tenant-administrator-invoices-container table th{\n        font-weight: 500;\n        padding: 10px 5px;\n        cursor: default;\n    }\n    .tenant-administrator-invoices-container table td{\n        font-size: 14px;\n        padding: 4px 5px;\n    }\n    .tenant-administrator-invoices-container table td:last-child img{\n        height: 25px;\n    }\n    .tenant-administrator-invoices-container table tr:nth-child(even){\n        cursor: pointer;\n        background-color: rgb(242, 242, 242);\n    }\n    .tenant-administrator-invoices-container table tr:nth-child(odd){\n        cursor: pointer;\n        background-color: rgba(206, 206, 206, 0.952);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
